import React from 'react'
import PropTypes from 'prop-types'

import { Card, Typography, Skeleton } from '@chilecompra/react-kit/components'

import { BINARY_CONFIRMATION_RESPONSE, DESCRIPTIONS_SUSTAINABILITY_DICTONARY } from '../../../config/settings/constants'

import { Grid, GridContainer } from '../DirectDealSummary.styles'

/**
 * The DirectDealSummary's details requirement.
 */
const DirectDealSummaryDetailRequirement = props => {
  const { loading, sheet } = props

  return (
    (sheet?.requirementEnviroment === BINARY_CONFIRMATION_RESPONSE[0].value ||
      sheet?.requirementSocial === BINARY_CONFIRMATION_RESPONSE[0].value) && (
      <Grid padding="16px 0 0">
        <Card color="success">
          <GridContainer>
            <Grid xs={12} margin="0 0 22px">
              {loading ? (
                <>
                  <Skeleton width="70%" />
                </>
              ) : (
                <Typography variant="body2" fontWeight="bold">
                  Esta compra es sustentable
                </Typography>
              )}
            </Grid>
            <Grid xs={12}>
              {loading ? (
                <>
                  <Skeleton width="70%" />
                  <Skeleton width="40%" />
                </>
              ) : (
                <>
                  {sheet?.requirementEnviroment === BINARY_CONFIRMATION_RESPONSE[0].value &&
                    sheet?.requirementSocial !== BINARY_CONFIRMATION_RESPONSE[0].value && (
                      <Typography variant="body2">{DESCRIPTIONS_SUSTAINABILITY_DICTONARY.ENVIROMENT}</Typography>
                    )}
                  {sheet?.requirementEnviroment !== BINARY_CONFIRMATION_RESPONSE[0].value &&
                    sheet?.requirementSocial === BINARY_CONFIRMATION_RESPONSE[0].value && (
                      <Typography variant="body2">{DESCRIPTIONS_SUSTAINABILITY_DICTONARY.SOCIAL}</Typography>
                    )}
                  {sheet?.requirementEnviroment === BINARY_CONFIRMATION_RESPONSE[0].value &&
                    sheet?.requirementSocial === BINARY_CONFIRMATION_RESPONSE[0].value && (
                      <Typography variant="body2">
                        {DESCRIPTIONS_SUSTAINABILITY_DICTONARY.ENVIROMENT_AND_SOCIAL}
                      </Typography>
                    )}
                </>
              )}
            </Grid>
          </GridContainer>
        </Card>
      </Grid>
    )
  )
}

DirectDealSummaryDetailRequirement.propTypes = {
  loading: PropTypes.bool,
  sheet: PropTypes.shape({
    requirementEnviroment: PropTypes.string,
    requirementSocial: PropTypes.string
  })
}

export default DirectDealSummaryDetailRequirement
